<!--SUBSCRIPTION ACCORDION-->
<section class="subscription-accordion">
  <!--SUBSCRIPTION DETAILS ACCORDION-->
  <ng-container *ngFor="let subscription of subscriptionItems; trackBy: trackBySubscriptionId">
    <!--SUBSCRIPTION DETAILS ACCORDION-->
    <ul class="manageEnrollmentContainer padding-bottom-small">
      <li class="subContainer">
        <span
          class="icon large red {{
            subscription.icon
          }} margin-left-large margin-right-small"></span>
        <div class="subscriptionInfoContainer">
          <h6>Subscription Details</h6>
          <span class="subscriptionNameContainer">
            <h4>
              <a
                class="gen-neutral-black-link"
                href="javascript:void(0);"
                [routerLink]="['/subscription', subscription.slugName]">
                {{ subscription.name }}
              </a>
            </h4>
          </span>
        </div>
        <div class="accordion-arrow">
          <a href="javascript:void(0);" (click)="onToggleNavigation(subscription.slugName)">
            <i
              class="icon small red margin-right-small"
              [ngClass]="toggleDropdown === subscription.slugName ? 'arrow-up' : 'arrow-down'">
            </i>
          </a>
        </div>
      </li>
      <!--END SUBSCRIPTION CONTAINER-->
      <!--SUBSCRIPTION DESCRIPTION-->
      <div class="subscriptionDescriptionContainer">
        <ng-container
          *ngIf="toggleDropdown === subscription.slugName"
          class="subscriptionDescription even-smaller-text">
          <p [innerHTML]="subscription.description"></p>
          <app-route-button
            [route]="'subscription/' + subscription.slugName"
            [routeType]="routeTypes.INTERNAL"
            [actionLabel]="cardTypeCallToActions.LEARN_MORE"
            [customButtonCss]="'btn-inverse margin-top-small'">
          </app-route-button>
          <div class="voucher-filter margin-top-small">
            <form [formGroup]="voucherLookupForm" (ngSubmit)="onVoucherSubmit(subscription)">
              <div class="voucher-box-container">
                <input
                  id="voucher-code"
                  type="text"
                  (ngModelChange)="onChange($event)"
                  [ngClass]="{ 'is-invalid': showVoucherCodeError }"
                  placeholder="Enter your voucher code"
                  formControlName="voucherCode" />
                <input
                  type="submit"
                  class="btn btn-primary"
                  [disabled]="!isVoucherCode"
                  value="Validate" />
              </div>
            </form>
          </div>
          <p class="vcode-details margin-bottom-large">
            <u class="margin-right-small">How will I receive a voucher code?</u>
            <app-information-tooltip
              [tooltipData]="
                'Voucher code(s) will be emailed to the purchaser of Genesys Education training. The purchaser will then distribute the voucher code(s) to the learners.'
              "
              [tooltipIcon]="'info-icon'"
              [iconSize]="'x-smallest'"
              [iconColor]="'red'">
            </app-information-tooltip>
          </p>
        </ng-container>
      </div>
      <!--END SUBSCRIPTION DESCRIPTION-->
    </ul>
  </ng-container>
  <!--END SUBSCRIPTION DETAILS ACCORDION-->
</section>
